
import { Input } from '../ui-kitNew/controlsNew'
import { Select } from '../ui-kitNew/selectNew'
import { MultiSelect } from '../ui-kitNew/multi-selectNew'
import { resolveField } from '../../lib/reportNew/fieldsNew'
import { operatorMeta } from '../../lib/reportNew/filtersNew'

/**
 * Control de valor que se adapta al operador elegido.
 * Es la pieza que hace que el filtrado sea "dinámico": no hay ningún
 * formulario escrito a mano por campo, todo se deriva de los metadatos.
 */
export function ValueInput({ condition, onChange, options = [], fields }) {
  const meta = operatorMeta(condition.field, condition.operator, fields)
  const field = resolveField(condition.field, fields)
  if (!meta) return null

  const set = (patch) => onChange({ ...condition, ...patch })

  switch (meta.input) {
    case 'none':
      return null

    case 'multi':
      return (
        <MultiSelect
          options={options}
          value={Array.isArray(condition.value) ? condition.value : []}
          onChange={(value) => set({ value })}
          placeholder="Elige valores…"
        />
      )

    case 'select':
      return (
        <Select
          size="sm"
          searchable={options.length > 8}
          options={options}
          value={condition.value}
          onChange={(value) => set({ value })}
          placeholder="Elige un valor…"
          ariaLabel={`Valor de ${field?.label}`}
        />
      )

    case 'number':
      return (
        <Input
          size="sm"
          type="number"
          inputMode="decimal"
          value={condition.value}
          onChange={(event) => set({ value: event.target.value })}
          placeholder={field?.unit ? `Valor en ${field.unit}` : 'Valor'}
          aria-label={`Valor de ${field?.label}`}
        />
      )

    case 'numberRange':
      return (
        <div className="flex flex-wrap items-center gap-1.5">
          <div className="min-w-[4rem] flex-1">
            <Input
              size="sm"
              type="number"
              value={condition.value}
              onChange={(event) => set({ value: event.target.value })}
              placeholder="Mín."
              aria-label="Valor mínimo"
            />
          </div>
          <span className="text-[12px] text-muted-foreground">y</span>
          <div className="min-w-[4rem] flex-1">
            <Input
              size="sm"
              type="number"
              value={condition.value2}
              onChange={(event) => set({ value2: event.target.value })}
              placeholder="Máx."
              aria-label="Valor máximo"
            />
          </div>
        </div>
      )

    case 'date':
      return (
        <Input
          size="sm"
          type="date"
          value={condition.value}
          onChange={(event) => set({ value: event.target.value })}
          aria-label={`Fecha de ${field?.label}`}
        />
      )

    case 'dateRange':
      return (
        <div className="flex flex-wrap items-center gap-3">
          <div className="min-w-[10.5rem] flex-1">
            <Input
              size="sm"
              type="date"
              value={condition.value}
              onChange={(event) => set({ value: event.target.value })}
              aria-label="Fecha desde"
            />
          </div>
          <span className="text-[12px] text-muted-foreground">y</span>
          <div className="min-w-[10.5rem] flex-1">
            <Input
              size="sm"
              type="date"
              value={condition.value2}
              onChange={(event) => set({ value2: event.target.value })}
              aria-label="Fecha hasta"
            />
          </div>
        </div>
      )

    case 'text':
    default:
      return (
        <Input
          size="sm"
          value={condition.value}
          onChange={(event) => set({ value: event.target.value })}
          placeholder="Escribe un texto…"
          aria-label={`Valor de ${field?.label}`}
        />
      )
  }
}
